
















import { Component, Vue, Prop } from "vue-property-decorator";
import ParticaMenu from "@/Ui-Components/Common/ParticaMenu/ParticaMenu.vue";
import { ListItemDTO } from "../../../Generated/ParticaAPI";
import { ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig } from "../../../Models/Buttons";

@Component({
	name: "ActionListV2",
	components: { ParticaMenu }
})
export default class ActionListV2 extends Vue {
	@Prop() private listdata: ListItemDTO[];
	@Prop() private menuactions: ButtonConfig[];

	private get list() {
		return this.listdata.sort();
	}
	private created() {
		if (!this.listdata) {
			throw new Error("listdata is undefined.");
		}
		if (!this.menuactions) {
			throw new Error("menuactions is undefined.");
		}
	}
	private handleEvent(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}
}
